import React from 'react';
import { styled } from '@mui/material/styles';
import { useSession } from 'next-auth/react';
import useMyLearning from '../../hooks/useMyLearning';
import { CONSTANTS } from '../../services/constants';

const getDisplay = (fields, session, isMyLearning) => {
  if (fields.hideComponent === 'session')
    return session ? 'display: none;' : 'display: flex;';
  if (fields.hideComponent === 'nosession') {
    return !session ? 'display: none;' : 'display: flex;';
  }
  if (fields.hideComponent === CONSTANTS.MY_LEARNING)
    return isMyLearning ? 'display: none;' : 'display: flex;';
  return 'display: flex;';
};

const Container = styled('div')(({ $display, $titleLongFormat }) => ({
  [($display === 'display: none;' ? '&' : '')]: {
    display: $display === 'display: none;' ? 'none' : 'flex',
  },
  display: 'flex',
  position: 'relative',
  flexDirection: 'row',
  backgroundRepeat: 'no-repeat',
  '@media screen and (min-width: 992px)': {
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundSize: '100%',
    backgroundPosition: 'right 15% bottom 25%',
    padding: '100px 250px',
    height: '431px',
  },
  '@media screen and (max-width: 991px)': {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    backgroundSize: '210%',
    backgroundPosition: 'right 35% bottom 35%',
    padding: $titleLongFormat ? '100px 40px 50px 40px' : '100px 40px',
    height: '330px',
    width: '99%',
  },
  '@media screen and (max-width: 400px)': {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    backgroundSize: '280%',
    backgroundPosition: 'right 25% bottom 45%',
    padding: $titleLongFormat ? '100px 40px 50px 40px' : '100px 40px',
    height: '300px',
    width: '99%',
  },
}));

const TextContainer = styled('div')(({ $titleLongFormat }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  minHeight: 'inherit',
  paddingRight: '10px',
  '@media screen and (min-width: 900px)': {
    width: $titleLongFormat ? '730px' : '582px',
    height: '280px',
  },
  '@media screen and (max-width: 899px)': {
    width: $titleLongFormat ? '95%' : '80%',
  },
}));

const HeroTitle = styled('div')({
  color: '#fff',
  fontWeight: 700,
  textTransform: 'uppercase',
  filter: 'drop-shadow(rgba(0, 0, 0, 0.25) 0 4px 4px)',
  '@media screen and (min-width: 900px)': {
    fontSize: '3.125rem',
    lineHeight: '3.375rem',
  },
  '@media screen and (max-width: 899px)': {
    fontSize: '2.55rem',
    lineHeight: '2.725rem',
  },
});

const HeroBackgroundAsImage = ({ module }) => {
  const { fields } = module;
  const { data: session } = useSession();
  const isMyLearning = useMyLearning();

  if (isMyLearning) {
    return;
  }

  const titleLongFormat = fields.title && fields.title.length > 60;

  return (
    <React.Fragment>
      <Container
        $display={getDisplay(fields, session, isMyLearning)}
        $titleLongFormat={titleLongFormat}
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)), url(${fields.backgroundImage.url})`,
        }}
      >
        <TextContainer $titleLongFormat={titleLongFormat}>
          <HeroTitle>{fields.title}</HeroTitle>
        </TextContainer>
      </Container>
    </React.Fragment>
  );
};

export default HeroBackgroundAsImage;
